import { render, staticRenderFns } from "./BiometricosCRUD.vue?vue&type=template&id=957638fc"
import script from "./BiometricosCRUD.vue?vue&type=script&lang=js"
export * from "./BiometricosCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports